<template>
  <Modal title="物流信息" :loading="true" v-model="modalVisible" :mask-closable="false">
    <Form class="sm" ref="form" :model="form" :label-width="90">
      <FormItem label="物流公司" prop="logisticsName">
        <Input placeholder="请输入物流公司" v-model="form.logisticsName"></Input>
      </FormItem>
      <FormItem label="物流单号" prop="mailNo">
        <Input placeholder="请输入物流单号" v-model="form.mailNo"></Input>
      </FormItem>
      <FormItem label="司机姓名" prop="driverName">
        <Input placeholder="请输入司机姓名" v-model="form.driverName"></Input>
      </FormItem>
      <FormItem label="司机号码" prop="driverPhone">
        <Input placeholder="请输入司机号码" v-model="form.driverPhone"></Input>
      </FormItem>
      <FormItem label="车牌" prop="dirverNumber">
        <Input placeholder="请输入车牌" v-model="form.dirverNumber"></Input>
      </FormItem>
      <FormItem label="备注信息" prop="remark">
        <Input type="textarea" placeholder="请输入备注信息" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      rules: {
        
      },
      form: {
        id: '',
        mailNo:null,
        logisticsName:null,
        driverName:null,
        driverPhone:null,
        dirverNumber:null,
        remark: null
      },
      orderId:null,
      loading:false
    }
  },

  created() {
    this.def = { ...this.form }
  },

  methods: {
    init(id) {
      this.$refs['form'].resetFields()

      if(id){
        this.orderId = id
        this.modalVisible = true
        this.query()
      }
    },
    query(){
      this.$request.orderLogisticsQuery(this.orderId).then(resp => {
        if(!resp.code){
          this.$utils.fill(this.form , resp.data[0])
        }else{
          this.$Message.error({content:resp.message})
        }
      })
    },
    save() {
      //
      let params = { orderId: this.orderId ,  ...this.form }

      this.loading = true
      this.$request.orderLogisticsUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
          // this.$keepAlive.update()
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    }
  }
}
</script>